export default {
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/~/react-transition-group/esm/config.js
// module id = 839
// module chunks = 121